export default {
  from: 'Plus de {from}',
  fromTo: "De {from} jusqu'à {to}",
  to: "Jusqu'à {to}",
}
